import { generatePath } from "react-router-dom";

import { ScenarioExecutionResultWithCase } from "src/types/scenario";

export function getScenarioVersionUrl(
  scenarioExecutionResult?: ScenarioExecutionResultWithCase | null
): string | null {
  if (!scenarioExecutionResult || !scenarioExecutionResult.scenarioVersion) {
    return null;
  }

  const { scenarioVersion } = scenarioExecutionResult;
  const { scenario, status, id } = scenarioVersion;

  if (status === "ACTIVE") {
    return generatePath("/scenario/:caseTypeCode/:id/active", {
      caseTypeCode: scenario?.caseTypeCode || null,
      id: scenario?.id || null,
    });
  } else if (status === "ARCHIVED") {
    return generatePath("/scenario/:caseTypeCode/:scenarioId/archived/:id", {
      caseTypeCode: scenario?.caseTypeCode || null,
      scenarioId: scenario?.id || null,
      id,
    });
  }

  return null;
}
